/* eslint-disable react/jsx-pascal-case */

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import {
  navLogedOperator,
  navLogedSub,
  navLogedClient,
} from "../../../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";
import { theme } from "../../../../helpers/theme";
import { ReactComponent as OrdersSvg } from "../../../../assets/icons/orders.svg";
import { ReactComponent as OrdersSvg_active } from "../../../../assets/icons/orders-active.svg";
import { ReactComponent as SettingsSvg } from "../../../../assets/icons/settings.svg";
import { ReactComponent as SettingsSvg_active } from "../../../../assets/icons/settings-active.svg";
import { ReactComponent as AccountSvg } from "../../../../assets/icons/account.svg";
import { ReactComponent as AccountSvg_active } from "../../../../assets/icons/account-active.svg";
import { ReactComponent as HelpSvg } from "../../../../assets/icons/help.svg";
import { ReactComponent as HelpSvg_active } from "../../../../assets/icons/help-active.svg";
import { StyledListItem, StyledListItemTex } from "./styles";

interface Role {
  role: number | null;
  isLoged: boolean;
}

const cssActivePageInLogedUser: any = {
  backgroundColor: `${theme.colors.white}`,
  // border: '1px solid #dfdfdf',
  borderRadius: "8px",
};

const LogedUser = ({ role, isLoged }: Role) => {
  let navigate = useNavigate();
  let location = useLocation();

  if (role === 0) {
    return (
      <>
        <List>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedOperator[0].url}`);
              }}
              sx={
                navLogedOperator[0].url === location.pathname
                  ? cssActivePageInLogedUser
                  : null
              }
            >
              <ListItemIcon>
                {navLogedOperator[0].url === location.pathname ? (
                  <OrdersSvg_active />
                ) : (
                  <OrdersSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedOperator[0].name}
                sx={{
                  color:
                    navLogedOperator[0].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedOperator[1].url}`);
              }}
              sx={
                navLogedOperator[1].url === location.pathname
                  ? cssActivePageInLogedUser
                  : null
              }
            >
              <ListItemIcon>
                {navLogedOperator[1].url === location.pathname ? (
                  <SettingsSvg_active />
                ) : (
                  <SettingsSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedOperator[1].name}
                sx={{
                  color:
                    navLogedOperator[1].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedOperator[2].url}`);
              }}
              sx={
                navLogedOperator[2].url === location.pathname
                  ? cssActivePageInLogedUser
                  : null
              }
            >
              <ListItemIcon>
                {navLogedOperator[2].url === location.pathname ? (
                  <AccountSvg_active />
                ) : (
                  <AccountSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedOperator[2].name}
                sx={{
                  color:
                    navLogedOperator[2].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedOperator[3].url}`);
              }}
              sx={
                navLogedOperator[3].url === location.pathname
                  ? cssActivePageInLogedUser
                  : null
              }
            >
              <ListItemIcon>
                {navLogedOperator[3].url === location.pathname ? (
                  <HelpSvg_active />
                ) : (
                  <HelpSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedOperator[3].name}
                sx={{
                  color:
                    navLogedOperator[3].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedOperator[4].url}`);
              }}
              sx={
                navLogedOperator[4].url === location.pathname
                  ? cssActivePageInLogedUser
                  : null
              }
            >
              <ListItemIcon>
                {navLogedOperator[4].url === location.pathname ? (
                  <HelpSvg_active />
                ) : (
                  <HelpSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedOperator[4].name}
                sx={{
                  color:
                    navLogedOperator[4].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
        </List>
        <Divider style={{ display: isLoged ? "none" : "block" }} />
      </>
    );
  } else if (role === 1) {
    return (
      <>
        <List>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedSub[0].url}`);
              }}
              sx={
                navLogedSub[0].url === location.pathname
                  ? cssActivePageInLogedUser
                  : ``
              }
            >
              <ListItemIcon>
                {navLogedSub[0].url === location.pathname ? (
                  <OrdersSvg_active />
                ) : (
                  <OrdersSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedSub[0].name}
                sx={{
                  color:
                    navLogedSub[0].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedSub[1].url}`);
              }}
              sx={
                navLogedSub[1].url === location.pathname
                  ? cssActivePageInLogedUser
                  : ``
              }
            >
              <ListItemIcon>
                {navLogedSub[1].url === location.pathname ? (
                  <SettingsSvg_active />
                ) : (
                  <SettingsSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedSub[1].name}
                sx={{
                  color:
                    navLogedSub[1].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          {/* <StyledListItem
            disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => { navigate(`${navLogedSub[2].url}`); }}
              sx={(navLogedSub[2].url === location.pathname) ? cssActivePageInLogedUser : ``}
            >
              <ListItemIcon>
                {((navLogedSub[2].url === location.pathname)) ? <AccountSvg_active /> : <AccountSvg />}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedSub[2].name}
                sx={{
                  color: navLogedSub[2].url === location.pathname ? `${theme.colors.blue01_active}` : `${theme.colors.gray01_secondaryText}`,
                }} />
            </ListItemButton>
          </StyledListItem> */}
          {/* <StyledListItem
          disablePadding>
          <ListItemButton
              disableRipple
              onClick={() => { navigate(`${navLoged[3].url}`) }}
              sx={(navLoged[3].url === location.pathname) ? cssActivePageInLogedUser : ``}
          >
              <ListItemIcon>
                  {((navLoged[3].url === location.pathname)) ? <HelpSvg_active /> : <HelpSvg />}
              </ListItemIcon>
              <StyledListItemTex
                  primary={navLoged[3].name}
                  sx={{
                      color: navLoged[3].url === location.pathname ? `${theme.colors.blue01_active}` : `${theme.colors.gray01_secondaryText}`,
                  }}
              />
          </ListItemButton>
      </StyledListItem> */}
        </List>
        <Divider />
      </>
    );
  } else if (role === 2) {
    return (
      <>
        <List>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedClient[0].url}`);
              }}
              sx={
                navLogedClient[0].url === location.pathname
                  ? cssActivePageInLogedUser
                  : ``
              }
            >
              <ListItemIcon>
                {navLogedClient[0].url === location.pathname ? (
                  <OrdersSvg_active />
                ) : (
                  <OrdersSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedClient[0].name}
                sx={{
                  color:
                    navLogedClient[0].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedClient[1].url}`);
              }}
              sx={
                navLogedClient[1].url === location.pathname
                  ? cssActivePageInLogedUser
                  : ``
              }
            >
              <ListItemIcon>
                {navLogedClient[1].url === location.pathname ? (
                  <SettingsSvg_active />
                ) : (
                  <SettingsSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedClient[1].name}
                sx={{
                  color:
                    navLogedClient[1].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          <StyledListItem disablePadding>
            <ListItemButton
              disableRipple
              onClick={() => {
                navigate(`${navLogedClient[2].url}`);
              }}
              sx={
                navLogedClient[2].url === location.pathname
                  ? cssActivePageInLogedUser
                  : ``
              }
            >
              <ListItemIcon>
                {navLogedClient[2].url === location.pathname ? (
                  <AccountSvg_active />
                ) : (
                  <AccountSvg />
                )}
              </ListItemIcon>
              <StyledListItemTex
                primary={navLogedClient[2].name}
                sx={{
                  color:
                    navLogedClient[2].url === location.pathname
                      ? `${theme.colors.blue01_active}`
                      : `${theme.colors.gray01_secondaryText}`,
                }}
              />
            </ListItemButton>
          </StyledListItem>
          {/* <StyledListItem
          disablePadding>
          <ListItemButton
              disableRipple
              onClick={() => { navigate(`${navLoged[3].url}`) }}
              sx={(navLoged[3].url === location.pathname) ? cssActivePageInLogedUser : ``}
          >
              <ListItemIcon>
                  {((navLoged[3].url === location.pathname)) ? <HelpSvg_active /> : <HelpSvg />}
              </ListItemIcon>
              <StyledListItemTex
                  primary={navLoged[3].name}
                  sx={{
                      color: navLoged[3].url === location.pathname ? `${theme.colors.blue01_active}` : `${theme.colors.gray01_secondaryText}`,
                  }}
              />
          </ListItemButton>
      </StyledListItem> */}
        </List>
        <Divider />
      </>
    );
  } else {
    return <></>;
  }
};

export default LogedUser;
